export enum ProspectProgress {
  Active = 'active',
  Replied = 'replied',
  Bounced = 'bounced',
  Unsubscribed = 'unsubscribed',
  Finished = 'finished',
  Paused = 'paused',
  Completed = 'completed',
  Inactive = 'inActive',
  Waiting = 'waiting',
  Upcoming = 'upcoming',
}

export enum OnProspectSequenceActions {
  MarkAsReplied = 'mark as replied',
  RemoveFromSequence = 'remove from sequence',
  MoveToStep = 'move to step',
  MarkAsFinished = 'mark as finished',
}

export enum BulkActionProspect {
  AddManually = 'Add Prospect Manually',
  AddToStep = 'Add To Step',
  RemoveProspect = 'Remove Prospect',
  Unsubscribe = 'Unsubscribe Prospect',
  ProspectDetail = 'Prospect Detail Tab',
  TagsUpdated = 'Updated Tags',
}

export enum ConversationType {
  All = 'all', // Get All Emails
  External = 'external', // Get External Emails Only
  System = 'system', // Get Sequence Emails Only
}

export enum ProspectSortBy {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  JobTitle = 'jobTitle',
  Department = 'department',
  Owner = 'owner',
  City = 'city',
  State = 'state',
  Country = 'country',
  CreateAt = 'createdAt',
  CompanyName = 'companyName',
  CompanyIndustry = 'companyIndustry',
  None = 'none',
  LastUpdated = 'lastUpdated',
  ProspectName = 'prospectName',
  DealValue = 'dealValue',
  ClosingDate = 'closingDate',
  // LastContactedAt = 'lastContactedAt',
  LastUpdatedAt = 'lastUpdatedAt',
  // TotalOpenCount = 'totalOpenCount',
  // TotalClickCount = 'totalClickCount',
  // LastClickedAt = 'lastClickedAt',
  // LastRepliedAt = 'lastRepliedAt',
}

export enum SupportedAiModelsServiceProvider {
  OpenAI = 'openai',
  Anthropic = 'anthropic',
  Google = 'google',
  Perplexity = 'perplexity',
  XAI = 'x-ai',
}

export enum EnrichmentTemplateCategory {
  MarketResearcher = 'marketResearcher',
  CompanyDataLookup = 'companyDataLookup',
  DataCleanup = 'dataCleanup',
  PeopleDataFinder = 'peopleDataFinder',
  DataClassifier = 'dataClassifier',
  SocialMedia = 'socialMedia',
  Miscellaneous = 'miscellaneous',
  ColdEmailAssistant = 'coldEmailAssistant',
  UserDefined = 'userDefined',
}

export enum ViewType {
  List = 'list',
  Kanban = 'kanban',
}

export enum ProspectNotePinUnpinActionType {
  Pin = 'pin',
  UnPin = 'unpin',
}
export enum ActivityBy {
  User = 'User',
  Prospect = 'Prospect',
  System = 'System',
}
